import lootOptions from './lootOptions';

// В рамках игры все единицы измерения в виртуальных метрах, кроме мест, где указано Px

// стоят реальные физические данные
const gameSettings = {
    // Коэффициент скорости игры относительно реальных величин
    speedOfGame: 2,
    // постоянное ускорение [м/с^2] 0.008 - default
    acceleration: 0.01,
    // начальная скорость [м/с]
    startVelocity: 3, // до 5
    // минимальная скорость, ниже которой она не может опуститься [м/с]
    minVelocity: 2,
    // максимальная скорость, выше которой она не может подняться [м/с]
    maxVelocity: 12,
    // // позиция игрока по осо y. влияет на то, в какой точке от низа экрана будет подбираться лут
    // playerYPos: 0,
    // playerYPosPt: 3,
    // начальное пройденное расстояние [м]
    startDistance: 0,
    /*
        В начале игры устанавливаем пройденное расстояние как -1 * beforeStartDistance
        и "крутим" игру, пока оно не станет 0. Это нужно, чтобы добавить повторяющиеся
        объекты на карту (разделительная полоса, бордюрные камни)
    */
    beforeStartDistance: 20,
    /*
        Объекты на обочине начинают появляться только когда пройденное расстояние > 0,
        по этому надо ещё чуть "прокрутить" игру, чтобы они не маячили на горизонте
        а были ближе к центру экрана на момент старта
    */
    beforeStartAdditionalDistance: 25,
    // расстояние окончания игры [м]
    finalDistance: 700,
    finalDistanceForView: 1000,
    // maxAnxiety: 3,
    // длительность защиты при подборе бонуса на защиту
    protectionDurations: {
        [lootOptions.PROTECTION_1]: 3000,
        [lootOptions.PROTECTION_2]: 3000,
        [lootOptions.PROTECTION_3]: 3000
    },
    /*
        значения для модификатора скорости при подборе лута
        если duration <= 0, то эффект будет постоянным
    */
    goodLootVelocityBonusValue: 1.2,
    goodLootVelocityBonusDuration: 3000,
    badLootVelocityBonusValue: -0.5,
    badLootVelocityBonusDuration: -1,
    /*
        количество лута на трассе
        good: плюс скорость
        bad: минус скорость
        protection: защита от плохого лута
        random: случайный выбор из всех вариантов
    */
    lootAmountByType: {
        [lootOptions.GOOD]: 50,
        [lootOptions.BAD_TREE_LEFT]: 6,
        [lootOptions.BAD_TREE_RIGHT]: 6,
        [lootOptions.BAD_ROADBLOCK]: 14,
        [lootOptions.BAD_HOLE]: 14,
        [lootOptions.BAD_POLICE]: 0, // 4
        [lootOptions.BAD_HOTDOG]: 0, // 5
        [lootOptions.BAD_SEWERAGE]: 14,
        [lootOptions.BAD_LOG]: 14,
        [lootOptions.PROTECTION_1]: 3,
        [lootOptions.PROTECTION_2]: 3,
        [lootOptions.PROTECTION_3]: 3,
        random: 12
    },
    // lootAmountByType: {
    //     [lootOptions.GOOD]: 55,
    //     [lootOptions.BAD_TREE_LEFT]: 0,
    //     [lootOptions.BAD_TREE_RIGHT]: 0,
    //     [lootOptions.BAD_ROADBLOCK]: 0,
    //     [lootOptions.BAD_HOLE]: 0,
    //     [lootOptions.BAD_POLICE]: 0,
    //     [lootOptions.BAD_HOTDOG]: 0,
    //     [lootOptions.BAD_SEWERAGE]: 0,
    //     [lootOptions.BAD_LOG]: 0,
    //     [lootOptions.PROTECTION_1]: 0,
    //     [lootOptions.PROTECTION_2]: 0,
    //     [lootOptions.PROTECTION_3]: 0,
    //     random: 0
    // },
    /*
        Для расстановки лута длина трассы делится на количество всего лута,
        чтобы получить расстояние между двумя соседними лут-элементами.
        Далее, для каждого элемента это расстояние =
        расстояние + расстояние * (от 0 до maxLootSpacingRandomnessFactor),
        чтобы добавить рандомности.
        При значении 0 весь лут будет расположен с равными интервалами,
        при значении 1 лут может наложиться на последующий элемент.
    */
    maxLootSpacingRandomnessFactor: 0.6,
    fps: 40000,
    secondsBeforeStart: 3,

    // sizes
    // высота дороги из макета
    roadHeightPx: 628,
    // roadHeightPtPx: 354,
    // видимое расстояние в метрах (для преобразования пикселей к метрам)
    roadHeightMeter: 10,
    // ширина видимой части дороги из макета
    roadWidthPx: 1920,
    // roadWidthPtPx: 375,

    figmaRoadSize: {
        botWidthPx: 3200,
        topWidthPx: 50,
        heightPx: 628
    },

    // figmaRoadSizePt: {
    //     botWidthPx: 912,
    //     topWidthPx: 18,
    //     heightPx: 354
    // },

    // additional params
    backgroundParams: {
        scaleFrom: 0.33,
        scaleTo: 1
    },
    spaceForIntersection: 2,
    spaceForIntersectionPt: 0.5,
    // Когда до финиша остается такое значение, больше не добавлять лут
    beforeFinishDistance: 14,
    // Пауза, прежде чем начнут появляться луты на дороге
    // secondsBeforeStartAddingLoots: 3,
    distanceBeforeStartAddingLoots: 20,
    // Время, которое висит экран финиша до того, как перекинет на таблицу лидеров
    finishScreenDuration: 8000,
    // Время с момента как машем флагом до показа результатов
    beforeFinishDelay: 2000,
    // Во сколько раз лут в конце трассы появляется чаще, чем в начале
    lootAddingStepEndModifier: 2
};

export const getGameCurrentWidthPx = () => document.getElementById('game').offsetWidth;
export const getGameCurrentHeightPx = () => document.getElementById('game').offsetHeight;
export const getIsGamePt = () => getGameCurrentWidthPx() / getGameCurrentHeightPx() < 2;

const toIncrementPxToCoord = () => {
    // const roadHeightPx = getIsGamePt() ? gameSettings.roadHeightPtPx : gameSettings.roadHeightPx;
    const { roadHeightPx } = gameSettings;

    return gameSettings.roadHeightMeter / roadHeightPx;
};

const getConvergencePointY = () => {
    // const roadSize = getIsGamePt() ? gameSettings.figmaRoadSizePt : gameSettings.figmaRoadSize;
    const roadSize = gameSettings.figmaRoadSize;

    const halfRoadWidthTop = roadSize.topWidthPx / 2;
    const halfRoadWidthBot = roadSize.botWidthPx / 2;

    return (halfRoadWidthBot * roadSize.heightPx) / (halfRoadWidthBot - halfRoadWidthTop);
};

export const incrementPxToCoord = toIncrementPxToCoord();
export const convergencePointY = getConvergencePointY().toFixed(2);

// export const getHalfRoadWidthAtY = (yCoord) => {
//     const fullRoadHeightCoord = convergencePointY * incrementPxToCoord;
//     const halfRoadWidthBotCoord = (gameSettings.figmaRoadBotWidthPx / 2) * incrementPxToCoord;

//     return (halfRoadWidthBotCoord * (fullRoadHeightCoord - yCoord)) / fullRoadHeightCoord;
// };

// export const getMovableObjectDistanceModAtY = (yCoord) => {
//     const fullRoadHeightCoord = convergencePointY * incrementPxToCoord;
//     const halfRoadWidthBotCoord = (gameSettings.figmaRoadBotWidthPx / 2) * incrementPxToCoord;

//     return (halfRoadWidthBotCoord * (fullRoadHeightCoord - yCoord)) / fullRoadHeightCoord;
// };

// TODO Если будем ограничивать область видимости, то надо поменять этот параметр

export default gameSettings;
